export default "__VITE_ASSET__CH8rLVw5__"